var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 7.24219C7.67157 7.24219 7 7.91376 7 8.74219V23.7422C7 24.5706 7.67157 25.2422 8.5 25.2422H23.5C24.3284 25.2422 25 24.5706 25 23.7422V8.74219C25 7.91376 24.3284 7.24219 23.5 7.24219H8.5ZM12.5208 11.2449C12.5264 12.2012 11.8106 12.7904 10.9612 12.7862C10.1611 12.7819 9.46357 12.1449 9.46779 11.2463C9.47201 10.4012 10.14 9.72194 11.0076 9.74163C11.8879 9.76132 12.5264 10.4068 12.5208 11.2449ZM16.2797 14.0039H13.7597H13.7583V22.5638H16.4217V22.3641C16.4217 21.9842 16.4214 21.6042 16.4211 21.2241C16.4203 20.2103 16.4194 19.1954 16.4246 18.1819C16.426 17.9358 16.4372 17.6799 16.5005 17.445C16.7381 16.5675 17.5271 16.0008 18.4074 16.1401C18.9727 16.2286 19.3467 16.5563 19.5042 17.0893C19.6013 17.4225 19.6449 17.7811 19.6491 18.1285C19.6605 19.1761 19.6589 20.2237 19.6573 21.2714C19.6567 21.6412 19.6561 22.0112 19.6561 22.381V22.5624H22.328V22.3571C22.328 21.9051 22.3278 21.4532 22.3275 21.0013C22.327 19.8718 22.3264 18.7423 22.3294 17.6124C22.3308 17.1019 22.276 16.5985 22.1508 16.1049C21.9638 15.3708 21.5771 14.7633 20.9485 14.3246C20.5027 14.0124 20.0133 13.8113 19.4663 13.7888C19.404 13.7862 19.3412 13.7828 19.2781 13.7794C18.9984 13.7643 18.7141 13.7489 18.4467 13.8028C17.6817 13.9561 17.0096 14.3063 16.5019 14.9236C16.4429 14.9944 16.3852 15.0663 16.2991 15.1736L16.2797 15.1979V14.0039ZM9.68164 22.5666H12.3324V14.0095H9.68164V22.5666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLinkedin);
export default __webpack_public_path__ + "static/media/black-linkedin.c682ac5f45fff0de5a96d059659e4a55.svg";
export { ForwardRef as ReactComponent };